<template>
  <div class="teacher-class-container">
    <div class="banner">
      <div class="banner-img">
        <img src="@/assets/images/banner/banner_2.png" alt="" />
      </div>
    </div>
    <div class="content">
      <div class="left-container">
        <a
          href="javascript:;"
          class="item"
          :class="{ active: index === navIndex }"
          v-for="(item, index) in navData"
          :key="index"
          @click="onSelectNav(index, item.path)"
        >
          <span>{{ item.name }}</span>
          <img
            src="@/assets/images/1.png"
            class="icon"
            alt=""
            v-show="index === navIndex"
          />
        </a>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      navData: [
        { id: 1, name: "资源下载", path: "/teacher/file/resource" },
        { id: 2, name: "下载记录", path: "/teacher/file/note" },
      ],
      navIndex: 0,
    };
  },
  created() {
    this.path = this.$route.path;
    this.navIndex = this.navData.findIndex((item) => item.path === this.path);
  },
  updated() {
    this.path = this.$route.path;
    this.navIndex = this.navData.findIndex((item) => item.path === this.path);
  },
  methods: {
    onSelectNav(i, path) {
      if (this.navIndex === i) {
        return false;
      }
      this.navIndex = i;
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/teacher.css";
.teacher-class-container .banner{
  width: 100%;
  height: 173px;
  background-image: url("../../assets/images/banner/bg_2.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>
